import api from './api';

/**
 * Service pour l'analyse financière des disputes
 */
class DisputeFinancialService {
  /**
   * Récupère l'analyse financière complète d'un dispute
   * @param {string} disputeId - UUID du dispute
   * @returns {Promise<object>} Analyse financière détaillée
   */
  async getFinancialAnalysis(disputeId) {
    const response = await api.get(`/disputes/${disputeId}/financial-analysis`);
    return response.data;
  }
}

export default new DisputeFinancialService();
